import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';

type IconButtonProps = {
  /**
   * Icon to display in the button
   */
  icon?: IconDefinition;
  /**
   * Function to call when button is clicked
   */
  onClick: () => void;
  /**
   * Additional classes to apply to the button
   */
  className?: string;
  /**
   * Size of the button (medium or large)
   */
  size?: 'sm' | 'md' | 'lg';
  /**
   * Whether the button is disabled
   */
  disabled?: boolean;
  /**
   * Type of the button (defaults to button)
   */
  type?: 'button' | 'close';
  /**
   * ARIA label for accessibility
   */
  ariaLabel?: string;
};

export const IconButton: React.FC<IconButtonProps> = ({
  icon = faPlus,
  onClick,
  className,
  size = 'md',
  disabled = false,
  type = 'button',
  ariaLabel,
}) => {
  const iconSize =
    size === 'sm'
      ? 'h-5 w-5'
      : size === 'md'
      ? 'h-6 w-6'
      : 'h-7 w-7 lg:h-8 lg:w-8';
  const buttonSize = size === 'sm' || size === 'md' ? 'h-10 w-10' : 'h-12 w-12';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={classNames(
        'duration-250 flex items-center justify-center rounded-full text-secondary transition-all hover:bg-gray-200 hover:text-primary active:bg-gray-200 active:bg-opacity-50',
        buttonSize,
        {
          'cursor-not-allowed opacity-50': disabled,
        },
        className
      )}
    >
      {type === 'close' ? (
        <FontAwesomeIcon
          //@ts-ignore
          icon={faXmark}
          className={classNames(iconSize, 'lg:h-6 lg:w-6')}
        />
      ) : (
        <FontAwesomeIcon
          //@ts-ignore
          icon={icon}
          className={classNames(iconSize, 'lg:h-6 lg:w-6')}
        />
      )}
    </button>
  );
};
